import type { ButtonDropdownItem } from 'components/actions/ButtonDropdown';

import { Status, type User } from 'API';

export const getUserFullName = (user?: Pick<User, 'firstName' | 'lastName'>) =>
    user ? `${user.firstName} ${user.lastName}` : undefined;

interface Props {
    openUserDialog: () => void;
    openResetPasswordDialog: () => void;
    openDeleteUserDialog: () => void;
    canEditUsers: boolean;
    canDeleteUsers: boolean;
    user?: User;
}

export const generateDropdownItems = ({
    openUserDialog,
    openResetPasswordDialog,
    openDeleteUserDialog,
    canEditUsers,
    canDeleteUsers,
    user,
}: Props): ButtonDropdownItem[] => {
    if (!user) {
        return [];
    }

    const items = [];

    if (canEditUsers && user.status === Status.ACTIVE) {
        items.push({
            value: (
                <span
                    className='SystemUsersRow__item SystemUsersRow__item--primary'
                    data-testid={`user-row-dropdown-item-reset-password-${user.id}`}
                >
                    <span className='rioglyph rioglyph-key SystemUsersRow__icon' />
                    <p className='SystemUsersRow__icon'>Reset password</p>
                </span>
            ),
            onSelect: () => openResetPasswordDialog(),
        });
    }

    if (canDeleteUsers) {
        items.push({
            value: (
                <span
                    className='SystemUsersRow__item SystemUsersRow__item--danger'
                    data-testid={`user-row-dropdown-item-delete-${user.id}`}
                >
                    <span className='rioglyph rioglyph-trash SystemUsersRow__icon' />
                    <p className='SystemUsersRow__icon'>Delete</p>
                </span>
            ),
            onSelect: () => openDeleteUserDialog(),
        });
    }

    if (canEditUsers) {
        items.unshift({
            value: (
                <span
                    className='SystemUsersRow__item SystemUsersRow__item--primary'
                    data-testid={`user-row-dropdown-item-edit-${user.id}`}
                >
                    <span className='rioglyph rioglyph-pencil SystemUsersRow__icon' />
                    <p className='SystemUsersRow__icon'>Edit</p>
                </span>
            ),
            onSelect: () => openUserDialog(),
        });
    }

    return items;
};

export const tableHeaders = (onClick: () => void) => ({
    firstName: 'First name',
    lastName: 'Last name',
    email: 'E-mail',
    phoneNumber: 'Phone',
    country: 'Country',
    city: 'City',
    team: 'Team',
    role: (
        <>
            Role
            <span
                className='rioglyph rioglyph-info-sign text-15 ml-5 cursor-pointer text-gray-dark'
                onClick={onClick}
            />
        </>
    ),
    status: 'Status',
    created: 'Created',
    updated: 'Updated',
    _: '',
});
